import {
  BATCH_INVENTORY_RESULTS_REQUESTED,
  BATCH_INVENTORY_RESULTS_SUCCESS,
  BATCH_INVENTORY_RESULTS_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  status: 'waiting',
  batchResults: [],
  errors: null
};

const batchInventoryResults = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case BATCH_INVENTORY_RESULTS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        batchResults: [],
        status: 'requesting'
      });

    case BATCH_INVENTORY_RESULTS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        batchResults: action.payload.batchResults,
        errors: null
      });

    case BATCH_INVENTORY_RESULTS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        batchResults: [],
        errors: 'error here'
      });

    default:
      return state;
  }
}


export default batchInventoryResults;